import React, { useEffect, useState } from 'react';
import { useSchedules } from '../Context/SchedulesContext';

export default function CommissionClone({ options, onCloneCommission }) {
  const [selectedId, setSelectedId] = useState('');
  const { schedulesByPlanId } = useSchedules();
  const handleChange = (event) => {
    const value = event.target.value;
    if (value) {
      setSelectedId(value);
      const [planId, scheduleId] = value.split('_').map(Number);

      onCloneCommission(planId, scheduleId, options.scheduleIndex);
    }
  };

  return (
    <>
      <select
        value={selectedId}
        onChange={handleChange}
        className="border-secondary form-control form-control-sm d-inline-block w-auto custom-select"
      >
        <option value="" disabled>
          Clone commission
        </option>

        {options.policyGroup.policies.map((policy) =>
          schedulesByPlanId[policy.plan.planId]
            ? schedulesByPlanId[policy.plan.planId].items
                .filter(
                  (_, index) =>
                    options.planId !== policy.plan.planId || index !== options.scheduleIndex
                )
                .map((option) => (
                  <option key={option.id} value={policy.plan.planId + '_' + option.id}>
                    {policy.plan.planName} &gt; {option.name}
                  </option>
                ))
            : ''
        )}
      </select>
    </>
  );
}
